import { Typography, useMediaQuery } from '@execonline-inc/execonline-ui';
import { AlreadyTranslated, AlreadyTranslatedText } from '@execonline-inc/translations';
import { observer } from 'mobx-react';
import { getDescriptionVariant } from './Types';

interface Props {
  description: AlreadyTranslatedText;
  className?: string;
}

function ExperienceDescription({ className, description }: Props) {
  const breakPoint = useMediaQuery();

  return (
    <Typography
      className={className}
      color="white"
      as="p"
      variant={getDescriptionVariant(breakPoint)}
    >
      <AlreadyTranslated content={description} />
    </Typography>
  );
}

export default observer(ExperienceDescription);
